import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Odometer tab body (SWOOP-161), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview/odometer`. Permission gating (`vehicles:list`) is inherited from the
 * layout route's `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/odometer')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-odometer-page')),
  staticData: { titleKey: 'vehicleOdometer' },
});
